<script setup lang="ts">

defineProps({
  error: {
    type: Object,
    required: true
  },
  onClickMethod: {
    type: Function,
    required: true
  }
})
</script>

<template>
  <div
    class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8"
  >
    <div class="mx-auto max-w-max">
      <SharedBasicsDefaultImage
        source="/logo_word_negative.svg"
        alt="SEC AUDITOR logo"
        class="mb-12"
        img-classes="h-12 w-auto mx-auto"
      />
      <main class="grid min-h-full place-items-center bg-white px-6 lg:px-8">
        <div class="text-center">
          <p class="text-base font-semibold text-red-light">
            Status: {{ error?.statusCode ? error.statusCode : error.code }}
          </p>
          <h1 class="mt-4 text-3xl font-bold tracking-tight text-secondary-lighter sm:text-4xl">
            {{ error?.title || error?.data?.title || "Uh, oh! Ein Fehler ist aufgetreten" }}
          </h1>
          <p class="mt-6 text-base leading-7 text-secondary-light">
            {{ error.message }}
          </p>
          <div class="mt-10 flex items-center justify-center gap-x-6">
            <button
              class="btn-standard-no-color bg-lilac text-common-white"
              @click="onClickMethod"
            >
              Zurück
            </button>
            <NuxtLink
              target="_blank"
              to="mailto:support@sec-auditor.com"
              class="btn-standard"
            >
              Support kontaktieren
            </NuxtLink>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<style scoped>

</style>
